<template>
    <div class="config-form">
      <el-card shadow="never">
        <el-form :model="form" :rules="rules" ref="form" label-width="120px">
          <el-form-item label="Redmine URL" prop="base_url">
            <el-input v-model="form.base_url" placeholder="https://your-redmine-instance.com"></el-input>
          </el-form-item>
          
          <el-form-item label="API Key" prop="api_key">
            <el-input v-model="form.api_key" placeholder="Your Redmine API key"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="submitForm">保存</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ConfigForm',
    data() {
      return {
        form: {
          base_url: '',
          api_key: ''
        },
        rules: {
          base_url: [
            { required: true, message: '请输入Redmine URL', trigger: 'blur' },
            { type: 'url', message: '请输入有效的URL', trigger: 'blur' }
          ],
          api_key: [
            { required: true, message: '请输入API Key', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.fetchConfig()
    },
    methods: {
      async fetchConfig() {
        try {
          const response = await this.$axios.get('/api/config')
          if (response.data.success) {
            this.form = {
              base_url: response.data.base_url || '',
              api_key: response.data.api_key || ''
            }
          }
        } catch (error) {
          this.$message.error('获取配置失败: ' + error.message)
        }
      },
      submitForm() {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              const response = await this.$axios.post('/api/config', this.form)
              if (response.data.success) {
                this.$emit('saved')
              } else {
                this.$message.error('保存失败: ' + (response.data.error || '未知错误'))
              }
            } catch (error) {
              this.$message.error('保存失败: ' + error.message)
            }
          }
        })
      },
      resetForm() {
        this.$refs.form.resetFields()
      }
    }
  }
  </script>
  
  <style scoped>
  .config-form {
    max-width: 800px;
    margin: 0 auto;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/ConfigForm.vue